module.exports = __webpack_public_path__ + "img/facebook.99f195ec.svg";